/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.3.26",
    versionName: "0.2.0-nightly.2026.3.26",
    versionChannel: "nightly",
    buildDate: "2026-03-26T00:13:15.063Z",
    commitHash: "18c74188d4a9690bce196cc1cea0d775e630e6cc",
};
